import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const isChunkLoadError =
      error?.name === 'ChunkLoadError' ||
      /Loading chunk [\d]+ failed/i.test(error?.message) ||
      /Failed to fetch dynamically imported module/i.test(error?.message);

    if (isChunkLoadError) {
      window.location.reload();
      return;
    }

    console.error(error);
  }
}